// The account whose games the store holds: the chess.com username the
// settings file keeps (`settings/chesscom.json`, written by the landing page
// and the settings panel). Only the username is read here; the file's
// shape is theirs.
export function readUsername(text: string | undefined): string {
  if (!text) return '';
  try {
    const raw = JSON.parse(text) as { schemaVersion?: number; username?: unknown };
    return raw.schemaVersion === 1 && typeof raw.username === 'string' ? raw.username : '';
  } catch {
    return '';
  }
}
